export default "/images/vendor/flag-icon-css/flags/1x1/mh.svg?7ec670b4d72f8a614957322d46619007";